import styled from 'styled-components';

const Wrapper = styled.div`
	width: 100%;
	height: auto;
	box-sizing: border-box;
	padding: 20px;
	h3 {
		font-family: HaasGrotDisp, -apple-system, system-ui;
		font-weight: bold;
		font-size: 24px;
		text-align: center;
		margin-bottom: 22px;
		color: #FFFFFF;
	}
	.ant-input {
		border: none !important;
        border-radius: 0%;
    }
	.ant-form-item {
		margin-bottom: 4px;
	}
	.ant-btn-primary {
		margin-top: 12px;
		font-weight: normal !important;
		background-color: #3A4FFF;
	}
	.link {
		text-align: center;
		font-size: 12px;
		margin-top: 12px;
		color: #b9b9b9;
		a {
			text-decoration: none;
		}
	}
	.contact-us {
		margin-top: 12px;
		font-size: 12px;
		color: #A8A8B1;
		text-align: center;
		span {
			color: #3A4FFF;
			cursor: pointer;
		}
	}
`;

export default Wrapper;
